import { render, staticRenderFns } from "./modalOpenOrders.vue?vue&type=template&id=47634dd0&scoped=true&"
import script from "./modalOpenOrders.vue?vue&type=script&lang=js&"
export * from "./modalOpenOrders.vue?vue&type=script&lang=js&"
import style0 from "./modalOpenOrders.vue?vue&type=style&index=0&id=47634dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47634dd0",
  null
  
)

export default component.exports